import merge from 'lodash.merge';
import { FunctionComponent } from 'react';
import { IconType } from 'react-icons';

interface ShiftRowProps {
  time: string;
  label: string;
  icon?: IconType;
  bgColor?: string;
  textColor?: string;
}

const ShiftRow: FunctionComponent<ShiftRowProps> = ({ time, label, icon: Icon, bgColor, textColor }) => (
  <div className="flex space-x-4 w-full">
    <p className="w-1/3 md:w-1/4 py-2 px-4 font-extrabold bg-white rounded-md shadow-sm shrink-0">{time}</p>
    <div
      className={merge('flex-1 min-w-0 flex items-center gap-2 py-2 px-4 font-semibold rounded-md shadow-sm')}
      style={{ backgroundColor: bgColor ? bgColor : '#FFF' }}
    >
      {Icon && <Icon className="w-5 h-5" style={textColor ? { color: textColor } : undefined} />}
      <span className="truncate" style={textColor ? { color: textColor } : undefined}>
        {label}
      </span>
    </div>
  </div>
);

export default ShiftRow;
